function checkIfProductGridready()
{
  let found = false;
  let attempts = 0;
  const maxAttempts = 10;
  const intervalTime = 250;

  let interval = setInterval(() => 
  {  
    if (!found) 
    {
      const element = document.querySelector('body.page--the-holiday-shop .product-grid .block');
      if (element) 
      {
        clearInterval(interval);
        found = true;
        
        wcAppendMultipleBanners();
      }
    }
    if (attempts >= maxAttempts) 
    {
      clearInterval(interval);
    }
    attempts++;
  }, intervalTime);

  function wcAppendMultipleBanners()
  { 
    const banners = [
     {
        image: 'https://cdn.shopify.com/videos/c/o/v/effb21463ba848af87dc91a1deac8fe6.mp4',
        url: 'https://ta3swim.com/products/sweetie-mesh-column-dress-sequin-black',
        index: 2
      },
      {
        image: 'https://cdn.shopify.com/videos/c/o/v/33270fd133874041975ba1f7c00fadf8.mp4',
        url: 'https://ta3swim.com/products/seamed-lushy-pencil-dress-lace-garnet',
        index: 7
      },
      {
        image: 'https://cdn.shopify.com/videos/c/o/v/3013cfe07d6a4f0b9563ba34799ed22d.mp4',
        url: 'https://ta3swim.com/products/sweetie-mesh-column-dress-sequin-pine',
        index: 12
      },
      {
        image: 'https://cdn.shopify.com/videos/c/o/v/8827285f7db1435389b2be9c44d23245.mp4',
        url: 'https://ta3swim.com/products/notchy-long-sleeve-midi-dress-black',
        index: 16
      },
      {
        image: 'https://cdn.shopify.com/videos/c/o/v/0aa81c03a1784a22a973853662f3d791.mp4',
        url: 'https://ta3swim.com/products/sweetie-mermaid-dress-ombre-garnet',
        index: 21
      },
      {
        image: 'https://cdn.shopify.com/videos/c/o/v/8f2a98c5feee4ec4af258957272a1bcb.mp4',
        url: 'https://ta3swim.com/products/sweetie-mermaid-dress-ombre-garnet',
        index: 26
      },
     {
        image: 'https://cdn.shopify.com/videos/c/o/v/d0c66b25229c4df5ae8c034265ce92e9.mp4',
        url: 'https://ta3swim.com/collections/new-arrivals',
        index: 32
      },
    ];
  
    banners.forEach((banner,key) => 
    {
      wcAppendMultipleBannersSub(banner.image, banner.url,banner.index, banner.index+key);
    });    
  }
  function wcAppendMultipleBannersSub(banner, url, index,updatedIndex)
  {
    let image = '<div class="block width--medium-3 spacing--3x product-banner party-edit"><a href="' + url + '"><video autoplay loop muted playsinline><source src="' + banner + '" type="video/mp4" /></video>SHOP NOW</a></div>';
    
    const afterSelector = `body.page--the-holiday-shop .product-grid .block:nth-child(${updatedIndex})`; 
    const afterBlock = document.querySelector(afterSelector);
    if (afterBlock) 
    {
      afterBlock.insertAdjacentHTML('afterend', image); 
    }
    else
    {
      setTimeout(() => {
        const afterBlock = document.querySelector(afterSelector);
        if(afterBlock)
        {
          afterBlock.insertAdjacentHTML('afterend', image); 
        }
        
      }, 250);
    }

    const currentSelector = `body.page--the-holiday-shop .product-grid .block:nth-child(${index})`;
    const currentBlock = document.querySelector(currentSelector);
    if (currentBlock) 
    {
      currentBlock.classList.add('sibling-added');
    }
    else
    {
      setTimeout(() => {
        const currentBlock = document.querySelector(currentSelector);
        if(currentBlock)
        {
          currentBlock.classList.add('sibling-added');
        }
      }, 250);
    }
  }
}
checkIfProductGridready();